import { selectRequestByType } from 'ducks/requests/selectors'
import { buildFetchFolderCountsRequestKey } from 'ducks/searches/utils/request'
import { selectAccountId } from 'ducks/accounts/selectors/selectAccountId'

export const selectSearchesRequestState = state =>
  selectRequestByType(
    state,
    buildFetchFolderCountsRequestKey(null, selectAccountId(state))
  )
